(() => {
  'use strict';
  const drawer = document.getElementById('cartOffCanvas');
  const tools = document.getElementById('native-cart-tools');
  if (!drawer || !tools) return;
  const strings = JSON.parse(document.getElementById('native-cart-translations').textContent);
  const root = window.Shopify?.routes?.root || '/';
  const feedback = document.getElementById('native-cart-feedback');
  const form = document.getElementById('native-cart-discount-form');
  const codeField = document.getElementById('native-cart-discount');
  const status = document.getElementById('native-cart-discount-status');
  const codeList = document.getElementById('native-cart-discount-codes');
  let cart = null;
  let discountBusy = false;
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: tools.dataset.currency || 'USD' }).format(value / 100);
  async function request(path, body) {
    const options = body ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) } : { cache: 'no-store' };
    const response = await fetch(root + path, options);
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || strings.discount_error);
    return data;
  }
  function update(data) {
    cart = data;
    form.hidden = data.item_count === 0;
    document.querySelectorAll('.cart_count_items, [data-cart-count]').forEach(el => { el.textContent = String(data.item_count); });
    const threshold = Number(tools.dataset.threshold) || 5000;
    const remaining = Math.max(0, threshold - data.total_price);
    const progress = document.getElementById('native-cart-shipping-progress');
    if (progress) {
      progress.value = Math.min(100, data.total_price / threshold * 100);
      progress.setAttribute('aria-label', remaining ? strings.remaining.replace('[amount]', money(remaining)) : strings.unlocked);
    }
    const label = document.getElementById('native-cart-shipping-label');
    if (label) label.textContent = remaining ? strings.remaining.replace('[amount]', money(remaining)) : strings.unlocked;
    document.getElementById('native-cart-share').hidden = data.item_count === 0;
    document.getElementById('native-cart-share').disabled = false;
    const original = data.items.reduce((sum, item) => sum + Math.max(item.original_price, item.selling_plan_allocation?.compare_at_price || 0) * item.quantity, 0);
    const originalTotal = document.getElementById('native-cart-original-total');
    originalTotal.hidden = original <= data.total_price;
    originalTotal.textContent = original > data.total_price ? money(original) : '';
    document.getElementById('native-cart-item-count').textContent = (data.item_count === 1 ? strings.item_count_single : strings.item_count).replace('[count]', data.item_count);
    const orderDiscounts = document.getElementById('native-cart-order-discounts');
    orderDiscounts.replaceChildren();
    (data.cart_level_discount_applications || []).forEach(discount => {
      const row = document.createElement('p');
      row.className = 'm-0';
      row.textContent = discount.title + ' (−' + money(discount.total_allocated_amount) + ')';
      orderDiscounts.append(row);
    });
    codeList.replaceChildren();
    (data.discount_codes || []).filter(code => code.applicable).forEach(code => {
      const row = document.createElement('div');
      row.append(document.createTextNode(code.code));
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = strings.remove;
      remove.setAttribute('aria-label', strings.remove + ' ' + code.code);
      remove.addEventListener('click', () => applyDiscount(null, code.code));
      row.append(remove);
      codeList.append(row);
    });
  }
  async function applyDiscount(code, removed) {
    if (discountBusy) return;
    discountBusy = true;
    const submit = form.querySelector('[type="submit"]');
    submit.disabled = true;
    codeField.disabled = true;
    status.textContent = '';
    try {
      cart = await request('cart.js');
      const codes = (cart.discount_codes || []).filter(c => c.applicable && c.code !== removed).map(c => c.code);
      if (code && !codes.some(c => c.toUpperCase() === code.toUpperCase())) codes.push(code);
      const result = await request('cart/update.js', { discount: codes.join(',') });
      update(result);
      const applied = !code || result.discount_codes?.some(c => c.applicable && c.code.toUpperCase() === code.toUpperCase());
      status.textContent = applied ? (code ? strings.applied : '') : strings.invalid;
      if (applied) codeField.value = '';
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (error) {
      status.textContent = strings.discount_error;
    } finally {
      discountBusy = false;
      submit.disabled = false;
      codeField.disabled = false;
    }
  }
  form.addEventListener('submit', event => {
    event.preventDefault();
    const code = codeField.value.trim();
    if (code) applyDiscount(code);
  });
  document.addEventListener('native-cart:updated', event => update(event.detail.cart));
  document.getElementById('native-cart-share').addEventListener('click', async () => {
    const button = document.getElementById('native-cart-share');
    button.disabled = true;
    try {
      const data = await request('cart.js');
      const items = data.items.map(item => ({ id: item.variant_id, quantity: item.quantity, ...(item.selling_plan_allocation ? { selling_plan: item.selling_plan_allocation.selling_plan.id } : {}) }));
      const codes = (data.discount_codes || []).filter(c => c.applicable).map(c => c.code);
      const url = new URL(root, location.origin);
      url.searchParams.set('shared_cart', btoa(JSON.stringify({ items, codes })));
      try {
        await navigator.clipboard.writeText(url.href);
        feedback.textContent = strings.copied;
      } catch {
        feedback.replaceChildren(document.createTextNode(strings.copy_error + ' '));
        const link = document.createElement('a');
        link.href = url.href;
        link.textContent = url.href;
        feedback.append(link);
      }
    } catch {
      feedback.textContent = strings.share_error;
    } finally {
      button.disabled = false;
    }
  });
  async function restoreSharedCart() {
    const current = new URL(location.href);
    const encoded = current.searchParams.get('shared_cart') || current.searchParams.get('rebuy_cart');
    if (!encoded) return;
    let previous = null;
    let replaced = false;
    try {
      const payload = JSON.parse(atob(encoded));
      if (!Array.isArray(payload.items) || !payload.items.length || payload.items.length > 20) throw new Error();
      const items = payload.items.map(item => {
        if (!Number.isSafeInteger(item.id) || item.id <= 0 || !Number.isInteger(item.quantity) || item.quantity < 1 || item.quantity > 999) throw new Error();
        if (item.selling_plan && (!Number.isSafeInteger(item.selling_plan) || item.selling_plan < 1)) throw new Error();
        return { id: item.id, quantity: item.quantity, ...(item.selling_plan ? { selling_plan: item.selling_plan } : {}) };
      });
      const codes = (Array.isArray(payload.codes) ? payload.codes : []).filter(c => typeof c === 'string' && /^[A-Za-z0-9_-]{1,100}$/.test(c));
      feedback.textContent = strings.loading;
      current.searchParams.delete('shared_cart');
      current.searchParams.delete('rebuy_cart');
      history.replaceState({}, '', current.href);
      previous = await request('cart.js');
      await request('cart/clear.js', {});
      replaced = true;
      await request('cart/add.js', { items });
      await request('cart/update.js', { discount: codes.join(',') });
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      feedback.textContent = strings.loaded;
      window.bootstrap?.Offcanvas.getOrCreateInstance(drawer).show();
    } catch {
      if (replaced && previous) {
        try {
          await request('cart/clear.js', {});
          const items = previous.items.map(item => ({ id: item.variant_id, quantity: item.quantity, properties: item.properties || {}, ...(item.selling_plan_allocation ? { selling_plan: item.selling_plan_allocation.selling_plan.id } : {}) }));
          if (items.length) await request('cart/add.js', { items });
          await request('cart/update.js', { discount: (previous.discount_codes || []).filter(c => c.applicable).map(c => c.code).join(','), note: previous.note || '', attributes: previous.attributes || {} });
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch { /* The cart still remains editable if inventory has changed. */ }
      }
      feedback.textContent = strings.share_error;
    }
  }
  request('cart.js').then(update).catch(() => {});
  restoreSharedCart();
})();
